import { defineNuxtPlugin } from 'nuxt/app'

export default defineNuxtPlugin(async () => {
    const messages = await import('~/locales/id.json')

    const t = (key: string): string => {
        return messages.default[key] || key
    }

    return {
        provide: {
            t: t as (key: string) => string,
        },
    }
})
